<div
  class="relative"
  [ngClass]="{
    'layout-wrapper-closed': isSidebarOpen() === false,
    'layout-wrapper': isSidebarOpen() === true,
  }">
  <div class="sidebar">
    <logibids-sidebar></logibids-sidebar>
  </div>

  <div class="layout-main-container">
    <div class="layout-topbar">
      <logibids-header></logibids-header>
    </div>

    <div class="layout-main">
      <router-outlet></router-outlet>
    </div>
    <div class="layout-footer">
      <logibids-footer></logibids-footer>
    </div>
  </div>
</div>
